<template>
  <div class="forget">
    <nav-bar fixed z-index="99" title="找回密码" left-text="返回" left-arrow @click-left="$router.go(-1)" />
    <div style="height: 46px"></div>
    <div class="register-title">找回密码</div>
    <form class="register-form" @submit.prevent="submit">
      <div>
        <div class="register-form-name"><span>*</span>手机号</div>
        <div class="register-form-input acea-row row-between-wrapper">
          <input class="w-f" placeholder="请输入手机号" v-model="account" />
        </div>
        <div class="register-form-name"><span>*</span>验证码</div>
        <div class="register-form-input acea-row row-between-wrapper">
          <input style="width: 3rem;" placeholder="请输入验证码" v-model="captcha" />
          <div class="text-num" @click="code">{{ text }}</div>
        </div>
        <div class="register-form-name"><span>*</span>密码</div>
        <div class="register-form-input acea-row row-between-wrapper">
          <!-- <input type="password"  class="w-f" placeholder="请输入密码" v-model="password" /> -->
          <NfInput borderInnerSize="0" borderSize="0" padding="0" round=".5rem" :value.sync="password" placeholder="请输入密码"
            type="password" />
        </div>
        <div class="register-form-name"><span>*</span>确认密码</div>
        <div class="register-form-input acea-row row-between-wrapper">
          <!-- <input type="password"  class="w-f" placeholder="请再次输入密码" v-model="sub_password" /> -->
          <NfInput borderInnerSize="0" borderSize="0" padding="0" round=".5rem" :value.sync="sub_password"
            placeholder="请再次输入密码" type="password" />
        </div>
        <div style="font-size: 0.23rem;margin-top: 0.6rem;color: #999999;">
          <Checkbox shape="square" v-model="agree" checked-color="#0ce6df">
            我已阅读并同意
            <router-link :to="'/view_detail/41'" style="color: #0ce6df">《用户协议》</router-link>
            和
            <router-link :to="'/view_detail/49'" style="color: #0ce6df">《隐私政策》</router-link>
          </Checkbox>
        </div>
        <div class="btn" style="margin-top: 0.4rem" @click="submit">
          确定
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import { passForget, registerVerify } from "@api/user";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import cookie from "@utils/store/cookie";
import { Checkbox, NavBar } from "vant";
import NfInput from "@/components/game-ui/NfInput.vue";

export default {
  name: "Forget",
  components: { Checkbox, NavBar, NfInput },
  mixins: [sendVerifyCode],
  data: function () {
    return {
      account: "",
      password: "",
      sub_password: "",
      captcha: "",
      formItem: 1,
      type: "login",
      codeText: "获取验证码",
      agree: false,
    };
  },
  methods: {
    async code() {
      var that = this;
      const { account } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message()),
            ],
          })
          .validate({ account });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      if (that.formItem == 2) that.type = "register";
      await registerVerify({ phone: that.account, type: that.type })
        .then((res) => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch((res) => {
          that.$dialog.error(res.msg);
        });
    },
    async submit() {
      console.log("spread:" + cookie.get("spread"));
      const { account, password, captcha, sub_password } = this;
      try {
        await this.$validator({
          account: [
            required(required.message("账号")),
            attrs.range([5, 16], attrs.range.message("账号")),
            alpha_num(alpha_num.message("账号")),
          ],
          captcha: [
            required(required.message("验证码")),
            attrs.range([6, 16], attrs.range.message("验证码")),
            alpha_num(alpha_num.message("验证码")),
          ],
          password: [
            required(required.message("密码")),
            attrs.range([6, 16], attrs.range.message("密码")),
            alpha_num(alpha_num.message("密码")),
          ],
          sub_password: [
            required(required.message("确认密码")),
          ]
        }).validate({ account, captcha, password, sub_password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      if (this.sub_password != this.password) {
        this.$dialog.toast({ mes: "两次输入的密码不一致" });
        return;
      }
      if (!this.agree) {
        this.$dialog.toast({ mes: "请勾选阅读并同意用户协议" });
        return;
      }
      passForget({ username: account, password, captcha })
        .then((res) => {
          this.$dialog.success(res.msg);
          setTimeout(() => {
            this.$router.go(-1);
          }, 2000)
        })
        .catch((e) => {
          this.$dialog.error(e.msg);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.forget {
  padding: 0.77rem 0.64rem;
  height: 100vh;
  background: #ffffff;
  position: relative;

  .register-title {
    font-size: 0.42rem;
    font-weight: 700;
  }

  .register-title-text {
    color: #999999;
    margin-top: 0.19rem;
  }

  .register-form {
    margin-top: 0.23rem;
  }

  .register-form-name {
    margin-bottom: 0.19rem;
    margin-top: 0.44rem;
  }

  .register-form-input {
    height: 0.78rem;
    padding: 0 0.23rem;
    background-color: #f8f8f8;
    border-radius: 2rem;
  }

  .text-num {
    color: #b9bde5;
  }

  .btn {
    display: block;
    color: #fff;
    width: 100%;
    height: 0.68rem;
    background: #0ce6df;
    line-height: 0.68rem;
    text-align: center;
    border-radius: 0.5rem;
  }
}
</style>
